import BookForm from "components/shared/book/form";
import React from "react";
import { config, initialState } from "../formConfig";
import Markup from "./markup";

class FormTracker extends BookForm {
    applyReq = (serialized) => {
        return this.props
            .submit({ ...serialized })
            .then((res) => (res ? this.close() : this.setState({ isLoading: false, isValid: false })));
    };

    renderBody = () => {
        const { config } = this.props;
        return <Markup {...config} renderField={this.renderField} renderSelect={this.renderSelect} />;
    };
}

const ConfiguredForm = (props) => <FormTracker {...props} config={config(false)} initialState={initialState} />;

export default ConfiguredForm;
